import { Component, OnInit, ChangeDetectionStrategy, ViewEncapsulation, ChangeDetectorRef, ViewChild, Input } from '@angular/core';
import { LocalizationService } from 'app/shared/localization/localization.service';
import { AppAuthService } from 'app/shared/services/app-auth.service';
import { Router, ActivatedRoute } from '@angular/router';
import { NgForm } from '@angular/forms';
import {  Language, LoginStatus } from 'app/shared/model/enums';
import { AdvMessageService } from 'app/shared/services/message.service';
import { LoginService } from 'app/login/services/login.service';
import { environment } from 'environments/environment';
import { AppState, selectLanguageInCommonState } from 'app/app-state.index';
import { Store } from '@ngrx/store';
import { CommonService } from 'app/shared/services/common.service';


declare var google: any;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoginComponent implements OnInit {
  @ViewChild("loginForm") loginForm: NgForm;
  loginModel = { email: '', password: '' };
  icon: string = 'pi pi-arrow-right';
  invalidLogin = false;
  invalidLoginByGoogle = false;
  googleClientId: string;
  forgotPasswordMode = false;
  verificationMode = false;
  resetPasswordMode = false;
  resetEmail = '';
  verificationCode = '';
  newPassword = '';
  confirmPassword = '';
  currentToken='';
  userNotFound:boolean=false;
  passwordNotCorrect:boolean=false;
  currentLang;
  constructor(
    private _localizationService: LocalizationService,
    private store: Store<AppState>,
    private _appAuthService: AppAuthService,
    private messagesService: AdvMessageService,
    private router: Router,
    private route: ActivatedRoute,
    private _cdr: ChangeDetectorRef,
    private loginService: LoginService,
    private commonService: CommonService
  ) {
    store.select(selectLanguageInCommonState).subscribe(language => {
      this.currentLang = Language[language];
    })
  }

  ngOnInit(): void {
    this.loginModel.email = this._appAuthService.authEmail;
    this.googleClientId = environment.clientId;
    this.initializeGoogleSignIn();
    this.updateArrowIcon(this.currentLang);
    this._cdr.markForCheck();
  }

  doLogin() {
    if (!this.loginForm.valid) return;
    this.login();
  }

  login() {
    this.invalidLogin = false;
    this.invalidLoginByGoogle = false;
    this._appAuthService.login(this.loginModel.email, this.loginModel.password).subscribe(response => {
      if (response.status == 1) {
        this.invalidLogin = true;
        this._cdr.markForCheck();
      } else {
        this.afterLogin(response);
      }
    });
  }

  changeStatusInvalidLogin() {
    this.invalidLogin = false;
    this.invalidLoginByGoogle = false;
  }

  initializeGoogleSignIn() {
    setTimeout(() => {
      google.accounts.id.initialize({
        client_id: this.googleClientId,
        callback: (response) => {
          this._appAuthService.handleGoogleCredentialResponse(response).subscribe(response => {
            if (response.status == 1) {
              this.invalidLoginByGoogle = true;
              this._cdr.markForCheck();
            } else {
              this.afterLogin(response);
            }
          });
        }
      });
      google.accounts.id.renderButton(
        document.getElementById('googleSignInButton'),
        { theme: 'outline', size: 'x-large', text: 'signin_with', shape: 'rectangular', type: 'standard', width: '300px' }
      );
    }, 10);
  }

  afterLogin(response) {
    let errorMessage = null;
    switch (response.status) {
      case LoginStatus.Succeeded:
        this.loginService.closeLoginDialog();
        this.navigateToReturnUrl();
        break;
      case LoginStatus.BlockedUser:
        errorMessage = this._localizationService.Translate("LOGIN.MESSAGES.BLOCKED_USER");
        break;
      case LoginStatus.RequiredVerification:
        errorMessage = this._localizationService.Translate("LOGIN.MESSAGES.VERIFICATION_CODE_REQUIRED");
        break;
      case LoginStatus.VerificationCodeSent:
        errorMessage = this._localizationService.Translate("LOGIN.MESSAGES.VERIFICATION_CODE");
        break;
      case LoginStatus.InvalidVerificationCode:
        errorMessage = this._localizationService.Translate("LOGIN.MESSAGES.INVALID_VERIFICATION_CODE");
        break;
      default:
        errorMessage = this._localizationService.Translate("ERROR_MESSAGES.UNKNOWN_ERROR");
        break;
    }
    if (errorMessage) this.messagesService.errorMessage(errorMessage, false);
    this._cdr.markForCheck();
  }

  navigateToReturnUrl() {
    const returnUrl = this.route.snapshot.queryParams.returnUrl;
    if (returnUrl) {
      this.router.navigate([returnUrl]);
    }
  }

  forgotPassword() {
    this.forgotPasswordMode = true;
    this.invalidLogin=false;
    this.invalidLoginByGoogle=false;
    this.resetEmail=""
    this.verificationCode=""
    this.newPassword = '';
    this.confirmPassword = '';
  }
  sendEmailAgain()
  {
     this.verificationMode=false;
     this.forgotPassword()
  }
  sendVerificationCode() {
    this.commonService.blockScreen(true);
    this.loginService.sendVerificationCode(this.resetEmail, this.currentLang)
      .subscribe(res => {
        if (res.Status == 2) {
          this.userNotFound=true;
          this.commonService.blockScreen(false);
          this._cdr.markForCheck()
        }
        else {
          this.userNotFound=false
          this.forgotPasswordMode = false;
          this.commonService.blockScreen(false);
          this.verificationMode = true;
          this._cdr.markForCheck()
        }
      },
    err=>{
            this.messagesService.errorMessage(this._localizationService.Translate("ERROR_MESSAGES.UNKNOWN_ERROR"),false)
    })
  }

  verifyCode() {
    this.loginService.verifyCode(this.resetEmail, this.verificationCode).subscribe(res => {
      let respone = res
      if (respone.Status == 3) {
        this.passwordNotCorrect=true;
        this._cdr.markForCheck();
      }
      else {
        this.currentToken=res.Token;
        this.verificationMode = false;
        this.passwordNotCorrect=false;
        this.resetPasswordMode = true;
      }
      this._cdr.markForCheck();

    }, error => {
      this.messagesService.errorMessage(this._localizationService.Translate("LOGIN.MESSAGES.NOT_VALID_CODE"), false);
    });

  }

  resetPassword() {
    if (this.newPassword !== this.confirmPassword) {
      this.messagesService.errorMessage(this._localizationService.Translate("LOGIN.PASSWORD.MESSAGES.PASSWORDS_NOT_MATCH"), false);
      return;
    }
    this.loginService.changePassword(this.resetEmail, this.newPassword,this.currentToken).subscribe(
      res => {
        this.messagesService.successMessage(this._localizationService.Translate("LOGIN.MESSAGES.SUCCES_UPDATE_PASSWORD"), false)
        this.resetPasswordMode = false;
        this._cdr.markForCheck()
      },
      err => {
        this.messagesService.errorMessage(this._localizationService.Translate("LOGIN.MESSAGES.UPDATE_FAILED"), false);
      }
    )
  }
  backToLogin() {
    this.resetPasswordMode = false;
    this.forgotPasswordMode = false;
    this.verificationMode = false;
    this._cdr.markForCheck()
  }
  updateArrowIcon(lang: string) {
    if (lang === 'en') {
      this.icon = 'pi pi-arrow-left';
    } else {
      this.icon = 'pi pi-arrow-right';
    }
  }
 
}
